import { Controller } from "@hotwired/stimulus"

// Persists the latest settled slider key after older Turbo form submissions.
// The visible shell remains usable if persistence fails; a later settle retries.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.submissions = new Set()
    this.pendingKey = null
    this.inFlight = false
  }

  settled({ detail: { key } }) {
    if (!key || key === this.element.dataset.committedKey) return
    this.pendingKey = key
    this.flush()
  }

  submitStart(event) {
    this.submissions.add(event.detail.formSubmission)
  }

  submitEnd(event) {
    this.submissions.delete(event.detail.formSubmission)
    this.flush()
  }

  flush() {
    if (this.inFlight || this.submissions.size > 0 || !this.pendingKey) return

    const key = this.pendingKey
    this.pendingKey = null
    this.inFlight = true
    fetch(this.urlValue, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "",
      },
      body: new URLSearchParams({ key }),
    }).then((response) => {
      if (response.redirected && window.Turbo) window.Turbo.visit(response.url)
      else if (response.redirected) window.location.assign(response.url)
      else if (response.ok) this.element.dataset.committedKey = key
    }).catch(() => {}).finally(() => {
      this.inFlight = false
      this.flush()
    })
  }
}
